import { render, staticRenderFns } from "./SaleTaxGroupCustomerGroup.vue?vue&type=template&id=525b3705&"
import script from "./SaleTaxGroupCustomerGroup.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxGroupCustomerGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports